import RequiresAuth from '@website/components/auth/RequiresAuth';
import Inbox from '@website/components/chat/Inbox';
import CustomBreadcrumb from '@website/components/CustomBreadcrumb';
import { LayoutProps } from '@website/components/layouts/DefaultLayout';
import Header from '@website/components/layouts/Header';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';

export default function HostInbox() {
  const { query } = useRouter();

  if (!query.hostURL) return <LoadingPage />;

  return (
    <RequiresAuth>
      <Container className="pt-3 p-3">
        <CustomBreadcrumb
          items={[
            { text: 'Home', href: '/' },
            {
              text: 'Host Dashboard',
              href: `/hosts/dashboard/${query.hostURL}`,
            },
            { text: 'Inbox', active: true },
          ]}
        />

        <Inbox hostURL={query.hostURL as string} />
      </Container>
    </RequiresAuth>
  );
}

// Custom layout to remove the footer
HostInbox.Layout = function Layout({ children }: LayoutProps) {
  return (
    <>
      <Header />
      <div>{children}</div>
    </>
  );
};
